<template>
    <span
        :class="{'table-header__th-name': isSort}"
        @click="onToggleSort"
    >
        {{title}}
        <i
            v-if="isShowIconSort"
            :class="'th_arrow fa ' + sortStateActiveIcon"
        >
    </i>
    </span>

</template>

<script>
import schemeTable from '../../schemes/schemeTable';
let {tableSortStates} = schemeTable;
export default {
    name: 'TableHeader',
    /**
     * входные данные компонента
     * @property {boolean} isSort - условие сортировки
     * @property {number} sortState - состояние режима сортировки
     * @property {string} title - заголовок
     */
    props: {
        isSort: {
            type: Boolean,
            default: false
        },
        sortState: {
            type: Number,
            default: 0
        },
        title: {
            type:String,
            default: ''
        }
    },
    /**
     * данные компонента
     * @property {array} sortStates - режимы сортировок
     */
    data: () => ({
        sortStates: tableSortStates
    }),
    computed: {
        /**
         * иконка активного режима сортировки
         * @returns {string}
         */
        sortStateActiveIcon() {
            return this.sortStates[this.sortState].icon;
        },
        /**
         * условие отображения иконки сортировки
         * @returns {boolean}
         */
        isShowIconSort() {
            return this.sortState !== 0 && this.isSort === true;
        },
    },
    methods: {
        /**
         * переключить режим сортировки
         */
        onToggleSort() {
            if (this.isSort)
                this.$emit('onToggleSort', this.sortState);
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-header__th-name {
        cursor: pointer;
    }
    .th_arrow {
        position: absolute;
        margin: 1px 0 0 5px;
    }
</style>